// The Edit KR modal previews a typed KR name through this event; renderers own their DOM.
export const KR_NAME_PREVIEW_EVENT = 'wb:kr-name-preview';

// name === null drops the preview.
export const previewKrName = (metricId, name, originalName = '') => {
  const detail = { metricId, name, originalName };
  window.dispatchEvent(new CustomEvent(KR_NAME_PREVIEW_EVENT, { detail }));
};

// Ties the preview to the rendered metric; keeps the first stored name, as later edits overwrite it.
export const nextKrNamePreview = (prev, detail, metric) => {
  if (detail.name == null) return null;
  const originalName = prev?.metric === metric ? prev.originalName : detail.originalName;
  return { ...detail, originalName, metric };
};

// Re-apply the quarter prefix (e.g. "Q1: ") the displayed name carries over the stored one.
export const applyKrNamePreview = (displayedName, preview) => {
  const shown = String(displayedName ?? '');
  const original = String(preview.originalName ?? '');
  const prefix = original && shown.endsWith(original) ? shown.slice(0, shown.length - original.length) : '';
  const name = String(preview.name);
  return name.startsWith(prefix) ? name : prefix + name;
};
